import { Http, Response, Headers } from '@angular/http';
import { Injectable, Inject, Injector } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../../environments/environment';
import { AuthenticationService, Token } from './index';

@Injectable()
export class TokensService {

    private restURL = environment.apiURL + 'tokens/';

    constructor(private http: Http, private injector: Injector) {
    }

    changeClient(token: any, clientGuid: string) {
        var headers = this.injector.get(AuthenticationService).getHeaderByToken(token);

        return this.http.put(this.restURL + clientGuid, null, {
            headers: headers
        })
            .map((res: Response) => {
                return res.json();
            })

            .catch((error: any) => {
                return Observable.throw(new Error("Client change failed"));
            });
    }

    getClients(token: string) {
        var headers = this.injector.get(AuthenticationService).getHeaderByToken(token);

        return this.http.get(this.restURL + 'clients', {
            headers: headers
        })
            .map((res: Response) => {
                return res.json();
            })

            .catch((error: any) => {
                return Observable.throw(new Error("Clients check failed"));
            });
    }

    logout(token: string) {
        var headers = this.injector.get(AuthenticationService).getHeader();

        return this.http.delete(this.restURL, {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(new Error("Logout failed"));
            });
    }

    changePwd(password: string) {

        var headers = this.injector.get(AuthenticationService).getHeader();
        headers.append('password', password);

        return this.http.put(this.restURL + 'password', null, {
            headers: headers
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                if (error.status === 406) {
                    return Observable.throw(new Error("Password change failed"));
                }
            });
    }

    login(username: string, password: string) {

        var headers = new Headers();
        headers.append('logonName', username);
        headers.append('password', password);

        return this.http.post(this.restURL, '', {
            headers: headers
        })
            .map((res: Response) => {
                let token = res.json();
                return token;
            })
            .catch((error: any) => {
                if (error.status === 406) {
                    return Observable.throw(new Error("Login failed"));
                }
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/services/security/tokens.service.ts